module.exports = new __parcel__URL__("Norah.1b131c52.svg").toString();